import React from 'react';
import { func, string } from 'prop-types';

import { white, maroon } from 'constants/color';
import { RoundButton } from 'components/Buttons/';
import { ReactComponent as DeleteIcon } from 'icons/delete.svg';

/**
 * @param {{
 * caption : string
 * onClick : Function
 * isDisabled: boolean
 * }} param
 */
function DeleteButton({ onClick, caption = 'Delete', isDisabled = false }) {
  return (
    <RoundButton
      caption={caption}
      onClick={onClick}
      backColor={white}
      foreColor={maroon}
      borderColor={maroon}
      icon={<DeleteIcon />}
      isDisabled={isDisabled}
      className="delete-button"
    />
  );
}

DeleteButton.propTypes = {
  onClick: func,
  caption: string,
};

export default DeleteButton;
